import { render, staticRenderFns } from "./TextTemplateForm.vue?vue&type=template&id=c12cd188&"
import script from "./TextTemplateForm.vue?vue&type=script&lang=js&"
export * from "./TextTemplateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TextTemplateForm.vue"
export default component.exports